import Storage from './AppStorage';
import ThingsboardServices from './service/thingsboardServices'
import ChirpstackServices from './service/chirpstack/chirpstackServices';

export class AppCore {

    constructor(apiAuthError = (res)  => {return {}}) {
        this.storage = new Storage();

        this.restServices = {
            thingsboard: new ThingsboardServices(this.storage, apiAuthError),
            chirpstack: new ChirpstackServices(this.storage, apiAuthError),
        };

        this.restServices.thingsboard.setUpdateStateCbk(this.updateThingsboard);
        this.restServices.chirpstack.setUpdateStateCbk(this.updateChirpstack);
    }

    updateThingsboard = (newState) => { this.uiSlots.updateState({ thingsboard: newState }) }
    updateChirpstack = (newState) => { this.uiSlots.updateState({ chirpstack: newState }) }

    setSignals = (coreCallbacks) => { this.uiSlots = coreCallbacks; }

    getServices = () => this.restServices;
    
}
